export const da = {
    admin: {
        user: 'Kundemodusvisning',
        userModeDescription:
            'Ved at aktivere denne modus vil siden forhåndsvises, som den bliver præsenteret for kundene.',
    },
    app: {
        forvalter: 'Dashbord for fast ejendom',
        mittleieforhold: 'Mine lejebetingelser',
        openInSuperOffice: 'SuperOffice',
        verified: 'Verified',
        dynamics365: 'Dynamics 365',
        eiendomGpt: 'EiendomGPT',
    },
    auth: {
        authorizing: 'Logger ind...',
        loggingOut: 'Logger ud...',
        login: 'Log ind',
        logout: 'Log ud',
        // tslint:disable-next-line: max-line-length
        privacyDescription:
            'Ved at bruge dette websted accepterer du, at vi indsamler oplysninger, der bruges til at forbedre brugeroplevelsen for brugerne af dette websted. Læs mere om vores privatlivspolitik på ',
        privacyLinkTitle: 'side om beskyttelse af personlige oplysninger',
        sessionTimeout: 'Din session er udløbet',
        sessionTimeoutLoginAgain: 'Log ind igen',
    },
    breadcrumbs: {
        checkOff: 'Tjek ud',
        availibleArea: 'Ledig Areal',
        building: 'Lokaler',
        byggUtleie: 'Utleie',
        contractManagement: 'Kontraktsforvaltning',
        dashboard: 'Mine lejebetingelser',
        expiringArea: 'Kontraktsutløp',
        invoice: 'Faktura',
        listUsers: 'Brugere',
        message: 'Opslagstavle',
        registerUser: 'Registrer bruger',
        reports: 'Rapporter',
        searchUsers: 'Søg efter brugere',
        selectClient: 'Vælg kundeforhold',
        ticket: 'Sager',
        forvaltningsplan: 'Forvaltningsplan',
        environmentProfile: 'Miljøprofil',
        keyFigures: {
            area: 'Areal nøkkeltal',
            economy: 'Økonomi nøkkeltal',
        },
        project: {
            report: 'Projektrapport',
            schema: 'Projektform',
        },
        leverandor: {
            schema: 'Leverandørformular',
            documentation: 'Dokumentation',
            leverandorReport: 'Leverandørrapport',
        },
    },
    bygg: {
        favoritt: 'Tilføj favorit',
        removeFavorite: 'Fjern favorit',
        noBuildingsYet:
            'Du har ingen bygninger endnu, men du kan tilføje bygninger til favoritlisten via søgefeltet i topmenuen.',
        myBuildings: 'Mine bygninger',
        settings: {
            title: 'Indstillinger',
            saveChanges: 'Gem ændringer',
            showByggGrunn: 'Vis grund i oversigt over bygninger',
        },
    },
    chat: {
        tooltip: 'Chat med dashbord for fast ejendom om kontrakter',
    },
    comments: {
        title: 'Kommentarer: {{page}}',
        tooltip: 'Kommentarer',
        datePickerLabel: 'Vælg år',
        chooseYearDescription: 'Vælg hvilket år kommentaren gælder for',
        newComment: 'Ny kommentar',
        editComment: 'Rediger kommentar',
        edit: 'Rediger',
        delete: 'Slet',
        highlight: 'Fremhæv',
        readMore: 'Læs mere',
        resetHighlightsFrontpage: 'Nulstil fremhævninger på forsiden',
        close: 'Luk',
        pin: 'Fastgør',
        titleLabel: 'Titel',
        validation: {
            titleTooLong: 'Titlen må ikke være længere end 50 tegn',
            titleOutOfRange:
                'Titlen må ikke være kortere end 1 tegn eller længere end 50 tegn',
        },
        seeDetails: 'Se detaljer',
        updatedBy: 'Opdateret af:',
        edited: 'Sidst redigeret: ',
        published: 'Udgivet: ',
    },
    editor: {
        paragraph: 'Afsnit',
        heading1: 'Overskrift 1',
        heading2: 'Overskrift 2',
        heading3: 'Overskrift 3',
        heading4: 'Overskrift 4',
        heading5: 'Overskrift 5',
        heading6: 'Overskrift 6',
        horizontalRule: 'Vandret linje',
        insertTable: 'Indsæt tabel',
        loadingEditor: 'Indlæser editor...',
        addColumnBefore: 'Ny kolonne før',
        addColumnAfter: 'Ny kolonne efter',
        deleteColumn: 'Slet kolonne',
        addRowBefore: 'Ny række før',
        addRowAfter: 'Ny række efter',
        deleteRow: 'Slet række',
        deleteTable: 'Slet tabel',
    },
    contractFrame: {
        externalFrame: {
            actionButton: 'Åbne kontraktsforvaltning',
            contractNotFoundTitle: 'Leder du efter dine lejevilkår?',
            contractNotFoundDescription:
                'Du kan finde alle dine bygnings aktuelle lejevilkår under den respektive bygning',
            contractNotFoundLink: 'Gå til mine ejendomme',
            manualContractDescription:
                'Du kan få en kopi af dine kontrakter i PDF-form ved at kontakte din KLP ejendomsadministrator',
            manualContractTitle: 'Leder du efter et eksisterende PDF-kontrakt?',
            title: 'Kontraktforhandling skal åbnes i en ny fane',
            description:
                'For at åbne Kontraktforhandlingerne skal vi bruge en ny fane',
        },
    },
    dxboFrame: {
        externalFrame: {
            actionButton: 'Åbne projekter',
            description: 'For at åbne projekter skal vi bruge en ny fane',
            title: 'Projekter skal åbnes i en ny fane',
        },
    },
    environment: {
        // tslint:disable-next-line: max-line-length
        description:
            'Denne service kan være ustabil i nogle perioder. Vi udvikler og forbedrer vores tjeneste hele tiden, og vi værdsætter alle dine forslag og feedback.',
        dev: 'DEV',
        environment: 'Miljø: ',
        title: 'Miljø',
        miljoprofil: 'Bygningens miljøprofil',
        powerBi: 'Miljørapport',
        noContextSelected:
            'Du skal slå en bygningsafdeling op, før du kan se dette',
        local: 'Lokal',
        test: 'TEST',
    },
    faktura: {
        payments: 'Betalinger',
    },
    availableArea: {
        downloadSourceData: 'Download Tilgjængelige lokaler til Excel',
        filedownloadname: 'Ledigt_Område{{lastname}}{{region}}.xlsx',
        potentialRevenue: 'Potentiel markedsværdi',
        totalArea: 'Totalareal',
        table: {
            areaType: 'TYPE',
            buildingAddress: 'ADRESSE',
            buildingNo: 'NR.',
            floor: 'ETASJE',
            leaseObject: 'LEJEOBJEKT',
            leaseObjectId: 'LEJEOBJEKT ID',
            markedsprisLedigAreal: 'MARKEDSVÆRDI (NOK)',
            markedsprisPerM2: 'ENHETSPRIS',
            physicalArea: 'AREAL',
            property: 'EJENDOM',
            roomNo: 'SONE NR',
            noMatch:
                'Vi fandt ingen ledige lokaler for bygningsafdelingen{{buildingName}} og / eller porteføljen du har valgt.',
        },
    },
    file: {
        deleting_1: 'Sletter filen...',
        deleting: 'Sletter filene...',
        downloading: 'Downloader...',
        downloadingFinished: 'Download fuldført',
        fileNotFound: 'Filen blev ikke fundet',
        preview: 'Forhåndsvisning',
        previewDownload: 'FORHÅNDSVISNING / HENT',
        downloadFailed: 'Download mislykkedes',
        saving_1: 'Gemmer filen...',
        saving: 'Gemmer filene...',
        selectFiles_0: 'Vælg fil',
        selectFiles: 'Vælg filer',
    },
    expiringContracts: {
        expirationProfile: {},
        keyFigures: {
            availableArea: 'Ledig areal',
            availableAreaValue: 'Ledig markedsverdi',
        },
        table: {
            amountYear: 'NOK/ÅR',
            area: 'AREAL',
            areaType: 'TYPE',
            contractHeadExpiryDate: 'HOVEDUTLØP',
            contractLineExpiryDate: 'DETALJUTLØP',
            contractNumber: 'KONTRAKT',
            customerName: 'KUNDE',
            description: 'BESKRIVELSE',
            filterReset: 'Fjern filter',
            filterTitle: 'Filtre:',
            noMatch:
                'Vi fandt ingen udløbende kontrakter for bygningsafdelingen{{buildingName}} og / eller porteføljen du har valgt',
            pricePerAmount: 'NOK/STK',
            pricePerSquareMeter: 'NOK/m²',
            pricePerUnit: 'ENHETSPRIS',
            property: 'EIENDOM',
            sortingWeight: 'PRIORITET',
        },
        downloadSourceData: 'Download Udløbende Kontrakter til Excel',
        filedownloadname:
            'Udløbende_Kontrakter{{lastname}}{{region}}{{from}}{{to}}.xlsx',
    },
    checkOffContract: {
        title: 'Kontrakt {{kontraktnavn}}',
        signed: 'Signert: ',
        sender: 'Afsender: ',
        noSender: 'Ingen afsender',
        subTitle: '{{kundeNavn}} ({{kundeNummer}})',
        tableDescription:
            'Registrerede kontraktlinjer for {{kundeNavn}} ({{kundeNummer}})',
        receivers: 'Modtagere:',
        noReceivers: 'Ingen underskrivere.',
        noDocuments: 'Ingen dokumenter er blevet uploadet til denne kontrakt.',
        saveButton: 'Gem',
        saveButtonCompletedStep: 'Deling Mine Lejebetingelser',
        cancelButton: 'Afbryd',
        backButton: 'Tilbake til registreringsoversigten',
        document: 'Dokument:',
        missingDocument:
            'Desværre er dette dokument ikke tilgængeligt til download og visning',
        registerInD365: 'Registrer kontrakt i D365:',
        registreringProsessLink: 'Gå til tilmelding for: {{type}}',
        processHeader: {
            Kontrakt: 'Registrer kontrakt i D365:',
            Garanti: 'Registrer garanti',
            Innflytningsprotokoll: 'Registrer innflytting',
            Utflytningsprotokoll: 'Registrer utflytting',
        },
        error: 'Der opstod en fejl under hentning af kontraktdokument. Prøv igen senere.',
        tooltip:
            'Knappen er blevet deaktiveret, da det forrige trin ikke blev fuldført, eller fordi nåværende trin allerede er gennemført.',
        tooltipSendButton:
            'Knappen er deaktiveret, da kontraktdokumentet mangler kontraktlinjer.',
        shareButtonCompleted: 'Ændre deling til Mine lejebetingelser',
        shareButton: 'Deling Mine Lejebetingelser',
        startRegistrationButton: 'Start registrering',
        successfulSending: 'Kontraktdokumentet er blevet delt',
        shareDocumentHeading: 'Del kontraktdokument - {{kontraktnavn}}',
        secondaryTitle:
            'Link kontraktdokumentet for {{kundeNavn}} ({{kundeNummer}}) til registrerede kontraktlinjer',
        shareDocumentWarning:
            'NB! Del kun kontraktdokument, der allerede er registreret i D365',
        dialog: {
            title: 'Er du sikker på, at du ønsker at tildele til den valgte konsulent?',
            stepCompletion: 'Er du sikker på, at du vil fuldføre trinnet?',
        },
        notStartedActivity: 'Opgaven er ikke påbegyndt.',
        insufficientUserRole:
            "Opgaven kræver rollen(e) '{{role}}', du er ikke tildelt denne rolle.",
        completedActivity: 'Oppgaven blev udført af: {{name}}, {{date}}',
        adminInformation:
            "Opgaven kræver rollen '{{role}}' og er tildelt '{{assigned}}'. Du har admin-rolle og kan ændre/udføre opgaven.",
        roles: {
            Forvalter: 'Forvalter',
            Okonomi: 'Økonomi',
            QAOkonomi: 'Økonomi QA',
        },
        step: {
            // Vurder relevans
            Activity_1vr6y7a: {
                title: 'Vurder relevans',
                secondaryTitle: 'Er dokumentet relevant for registrering?',
                description:
                    'Ikke alle dokumenter fra Verified skal registreres. Vælg «Relevant», hvis dokumentet er en kontrakt, en indflytningsprotokol eller en fraflytningsprotokol, og vælg derefter dokumenttype. Vælg «Ikke relevant», hvis dokumentet ikke er en af disse, eller ikke er relevant.',
                notRelevantButton: 'Ikke relevant',
                relevantButton: 'Relevant',
                cta: 'Komplet trin',
                completeButton: 'Fuldfør',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
            // Tildel økonomikonsulent
            Activity_1rdcqtp: {
                title: 'Tildel finansiel konsulent',
                secondaryTitle: 'Vælg finansiel konsulent',
                tertiaryTitle: 'Vælg konsulent',
                descriptionPartOne:
                    'Vi har valgt byggeriets økonomirådgiver til dig.',
                descriptionPartTwo:
                    'Hvis du har brug for at ændre dette, kan du gøre det her.',
                cta: 'Tildel',
                chosenConsultant: 'Valgt konsulent:',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
            sendToRegistration: {
                title: 'Send til registrering',
                secondaryTitle: 'Registrering i Dynamics 365',
                descriptionPartOne:
                    'Vi har sendt meddelelse til {{navn}}, som vil registrere kontrakten i D365.',
                descriptionPartTwo:
                    'Du får besked, når kontrakten er registreret.',
                cta: 'Komplet trin',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
            // Utfør registrering i D365
            Activity_0hw9rg3: {
                title: 'Registerer i D365',
                secondaryTitle: 'Registrering i Dynamics 365',
                tertiaryTitle: 'Vælg konsulent',
                levendeKontrakterDescription:
                    'Baseret på oplysninger fra Levende Kontrakter har vi lavet et udkast til en ny kunde, {{kundeNavn}}, og et udkast til registrering af denne nye kontrakt ({{kundeNummer}}) til Onsite 365.',
                description:
                    'Tjek indholdet af kladden og fuldfør registreringen.',
                goToCustomer: 'Gå til kunde',
                goToContractDraft: 'Gå til kontrakt',
                goToLevendeKontrakter: 'Gå til Levende Kontrakter',
                errorStatusNewCustomer: 'Kunne ikke oprette en ny kunde',
                errorStatusNewContractDraft:
                    'Kunne ikke oprette en ny kontrakt',
                D365Button: 'Åbn Onsite365',
                cta: 'Komplet trin',
                completeButton: 'Fuldfør',
                selectController: 'Vælg controller til registrering',
                chosenConsultant: 'Valgt konsulent:',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
            // Kontroll av registrering i D365
            Activity_1bk3epl: {
                title: 'Kontrol af registrering i D365',
                descriptionPartOne:
                    'Hvis kontrakten er korrekt registreret i D365, kan den godkendes.',
                approveRegistrationButton: 'Godkend registrering',
                cta: 'Komplet trin',
                controlRegistration: 'Kontroller tinglyst kontrakt',
                goToLevendeKontrakter: 'Gå til Levende Kontrakter',
                goToCustomer: 'Gå til kunde',
                goToContractDraft: 'Gå til kontrakt',
                D365Button: 'Åpne Onsite365',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
            notifyManager: {
                title: 'Underret forvalter',
            },
            // Vurder gjennomgangsmøte
            Activity_1b84rij: {
                title: 'Overvej gennemgangsmøde',
                description:
                    'Er der tale om en større kontrakt, kan det være nødvendigt at holde et gennemgangsmøde med forvalter.',
                reviewMeetingButton: 'Gennemgangsmøde',
                continueButton: 'Fortsæt',
                cta: 'Komplet trin',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
            // Gjennomgangsmøte
            Activity_1m3ak5n: {
                title: 'Gennemgangsmøde',
                descriptionPartOne:
                    'Økonomi har nu færdiggjort registreringen af kontrakten i D365 og ønsker et gennemgangsmøde.',
                descriptionPartTwo:
                    'Forbered dig til mødet ved at gennemgå udkastet til fakturaen til kunden.',
                previewButton: 'Forhåndsvis faktura',
                approveRegistrationButton: 'Godkend registrering',
                cta: 'Komplet trin',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
            // Oppdater kundenummer i SuperOffice
            Activity_057tcgr: {
                title: 'Opdater kundenummer i SuperOffice',
                descriptionPartOne:
                    'Klik på dette link for at opdatere kundenummeret.',
                descriptionPartTwo:
                    'Hvis kundenummeret er korrekt registreret, kan du fuldføre det nuværende trin og fortsætte registreringen.',

                descriptionPartThree:
                    'Dette er nødvendigt for at se en oversigt over kontraktlinjer for kontraktdokumentet.',
                cta: 'Fuldfør trin',
                goToSuperoffice: 'Gå til SuperOffice',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
            // Knytt dokument og linje
            Activity_15vq4i6: {
                title: 'Forbind dokument og linje',
                secondaryTitle:
                    'Registrerede kontraktlinjer for {{kundeNavn}} ({{kundeNummer}})',
                table: {
                    validToDate: 'TIL',
                    validFromDate: 'FRA',
                    amount: 'ANTAL',
                    areal: 'AREAL',
                    yearlyPrice: 'NOK/ÅR',
                    kontraktId: 'KONTRAKT NR',
                    id: 'ID',
                    name: 'NAVN',
                    choose: 'VELG',
                    noRelevantContractLines:
                        'Vi fandt ingen relevante kontraktlinjer for kunden inden for underskriftsperioden.',
                },
                cta: 'Komplet trin',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
            complete: {
                title: 'Fuldfør',
                secondaryTitle: 'Oversigt over registrering',
                table: {
                    tenant: 'Lejer',
                    area: 'Areal',
                    leaseStart: 'Lejestart',
                    invoiceAmount: 'Faktura beløb',
                    property: 'Ejendom',
                    parking: 'Parkering',
                    endOfLease: 'Lejemålets ophør',
                    invoiceDate: 'Fakturadato',
                },
                completeRegistration: 'Fuldfør registrering',
                cancel: 'Afbryt',
                completedBy: 'Udført af: {{name}}, {{date}}',
            },
        },
        table: {
            validToDate: 'TIL',
            validFromDate: 'FRA',
            amount: 'ANTAL',
            areal: 'AREAL',
            yearlyPrice: 'NOK/ÅR',
            kontraktId: 'KONTRAKT NR',
            kontraktLinjeIds: 'ID',
            name: 'NAVN',
            choose: 'VELG',
            noRelevantContractLines:
                'Vi fandt ingen relevante kontraktlinjer for kunden inden for underskriftsperioden.',
        },
    },
    contractRegistration: {
        oppslag: {
            sokLabel: 'Søg (kundenavn eller kundenummer)',
            sokUtenFiltre:
                'Søger i alle kontrakter. Andre filtre er slået fra ved søgning.',
        },
        contractTypes: {
            Kontrakt: 'Kontrakt',
            Garanti: 'Garanti',
            Innflytningsprotokoll: 'Indflytning',
            Utflytningsprotokoll: 'Udflytning',
        },
        statuses: {
            checkedOff: 'Tjekket af',
            notCheckedOff: 'Ikke tjekket af',
            new: 'Ny',
            shallNotBeRegistered: 'Skal ikke registreres',
            withForvalter: 'Med manager',
            assignedFinance: 'Tildelt økonomi',
            registrationD365: 'Registrering D365',
            forApporval: 'Til godkendelse',
            toQA: 'Til QA',
            QACompleted: 'QA afsluttet',
            approved: 'Godkendt',
            completed: 'Færdig',
            RegistreringAvGaranti: 'Garantiregistrering',
        },
        table: {
            actionMenuItems: {
                restartProcess: 'Genstart proces',
                showDetails: 'Se detaljer',
                assignFinancePerson: 'Tildel øko. resp.',
                download: 'Hent',
                notRelevant: 'Ikke relevant',
            },
            contracts: {
                statusCode: {
                    success: 'Vi har fundet en ny registrering for denne kunde',
                    foundMultiple:
                        'Vi har fundet flere nye tilmeldinger. Dobbelttjek med økonomichefen',
                    foundMultipleWithCount:
                        'Vi har fundet {{count}} nye tilmeldinger inden for 14 dage efter underskrivelsen. Dobbelttjek med økonomichefen, at denne kontrakt er en af ​​disse.',
                    notFound: 'Vi kan ikke finde nogen information.',
                    error200:
                        'Vi kan ikke finde nogen modtagere for dokumentet i Verified eller Superoffice.',
                    error302:
                        'Vi kan ikke finde kundenummer. Kundenummeret kan være forkert i Superoffice, eller der er muligvis ingen kontakter, der matcher modtagerne.',
                    error300:
                        'Vi kan ikke finde en reference med en kontrakt. Enten er kontrakten ikke underskrevet endnu, eller også er den netop underskrevet. Der kan gå op til 14 dage fra underskrivelsen, før den er synlig.',
                    error303:
                        'Vi finder ikke en reference til kontrakten. Hvis der er gået mere end 14 dage mellem underskrift og tilmelding, vil det ikke fremgå her. Du kan kontakte økonomichefen for mere information.',
                    error301: 'Vi kan ikke finde bygningsnummer.',
                    error100:
                        'Vi kan ikke finde en reference til dokumentet. Dokumentet er ikke registreret via Verified eller Superoffice, men er blevet uploadet til Superoffice.',
                },
            },
            signDate: 'UNDERSKREVET',
            checkOff: 'TJEK UD',
            propertyManager: 'ADMINISTRATOR',
            economyPerson: 'ØKONOMI',
            contractDocument: 'DOKUMENT',
            property: 'EJENDOM',
            kundeNummer: 'KUNDE NR',
            action: 'HANDLING',
            tenant: 'LEJER',
            type: 'TYPE',
            registeredDate: 'Registrert',
            statusCode: {
                title: 'STATUS',
                error: 'Det er en feil i Dokumentet registrert i SuperOffice',
                noPropertyWarning:
                    'Vi kan ikke finde nogen oplysninger om ejendommen på denne kontrakt. En almindelig årsag er, at dokumentet i SuperOffice ikke er knyttet til et projekt eller et salg.',
                noEconomyWarning:
                    'Vi kan ikke finde ejendommens økonomichef. En vanlig årsak er at dokumentet i SuperOffice ikke er knyttet til et prosjekt eller et salg.',
                noTenantWarning:
                    'Vi kan ikke finde nogen oplysninger om ejendommen på denne kontrakt. En almindelig årsag er, at dokumentet i SuperOffice ikke er knyttet til et projekt eller et salg eller at kontakten ikke finnes.',
            },
            email: {
                helpTextForvalter: 'Send mail til byggets forvalter',
                helpTextOkonomi: 'Send mail til byggets økonomichef',
                subjectText: 'Registrering av kontrakt i ',
            },
            emptyTableMessage:
                'Vi kan ikke finde nogen kontrakter for bygnignsafdelingen og / eller porteføljen du har valgt.',
        },
        title: 'D365 registreringsopfølgning',
        notification: 'Behandling af anmodningen. Vent venligst..',
        error: 'Der opstod en fejl. Prøv igen senere.',
        errorSaveForm: 'Der opstod en fejl under lagring af formularindhold.',
        successfulRegistration: 'Kontraktdokumentet er registreret.',
        successfulOperation: 'Handlingen er gennemført.',
        newProcess: 'Nye dokumenter',
        ongoingProcessForvalter: 'Hos administrator',
        ongoingProcessFinance: 'Hos økonomi',
    },
    contractManagement: {
        leko: 'Kontraktforhandling',
        negotiation: 'Forhandling',
        overview: 'Kontrakter',
        registrer: 'Registrering',
        sign: 'Underskriv',
        title: 'Kontraktstyring',
        ongoingProcesses: 'Løbende processer',
        forSigning: 'Til underskrift',
        forRegistration: 'Til registrering',
    },
    contract: {
        amountYear: 'Kr/år',
        area: 'Brutto',
        availableArea: 'Ledig areal',
        availableAreaValue: 'Ledig markedsværdi',
        chartTitle: 'Udløbsprofil:',
        contractExpiry: 'Udløb',
        customerName: 'Kundenavn',
        expiringArea: 'Udløbende areal',
        expiringContracts: 'Udløbende kontrakter',
        ExpiringContracts: 'Utløbende kontrakter',
        expiringContractValue: 'Udløbende lejeindtægter',
        expiringLines:
            '{{contractCount}} kontraktlinjer udløber mellem {{from}} og {{to}}',
        expiry: {
            expired: 'Har udløbet',
            expires_within_1y: 'Udløber inden 1 år',
            expires_within_2y: 'Udløber inden 2 år',
            expires_within_3y: 'Udløber inden 3 år',
            expires_within_4y: 'Udløber inden 4 år',
            expires_within_6m: 'Udløber inden 6 mnd',
            eternal: 'Ingen udløbsdato',
        },
        expiryProfileTime: {
            expired: 'Udløbsprofil (Har udløbet):',
            expires_within_6m: 'Udløbsprofil (6 mnd):',
            expires_within_1y: 'Udløbsprofil (1. år):',
            expires_within_2y: 'Udløbsprofil (2 år):',
            expires_within_3y: 'Udløbsprofil (3 år):',
            expires_within_4y: 'Udløbsprofil (4 år):',
            eternal: 'Udløbsprofil (Ingen udløbsdato):',
        },
        expiryRateNOK: 'Udløbsgrad (NOK)',
        income: 'Lejeindtægt',
        keyFigures: 'Nøgletal ({{date}}):',
        keyFiguresTime: {
            expired: 'Nøkkeltall: (Har udløbet)',
            expires_within_6m: 'Nøkkeltall (6 mnd):',
            expires_within_1y: 'Nøkkeltall (1. år):',
            expires_within_2y: 'Nøkkeltall (2 år):',
            expires_within_3y: 'Nøkkeltall (3 år):',
            expires_within_4y: 'Nøkkeltall (4 år):',
            eternal: 'Nøkkeltall (Ingen udløbsdato)',
        },
        leasedArea: 'Utleid areal',
        lineExpiry: 'Linjeudløb',
        lineName: 'Beskrivelse',
        number: 'Kontrakt',
        pcs: 'stk',
        portfolioComposition: 'Porteføljesammensætning:',
        property: 'EJENDOM',
        rentalStatusPerDate: 'Utleiestatus ({{date}}):',
        selectExpiry: 'Velg udløb',
        sortingWeight: 'Vægt',
        title: 'Kontrakt',
        totalArea: 'Samlet areal',
        totalPotentialIncome: 'Samlet potentiel leje',
    },
    ledigAreal: {
        keyFigures: {
            areaAvailable: 'Ledig areal',
            areaLeased: 'Utleid areal',
            availableAreaValue: 'Ledig markedsværdi',
            rentalIncome: 'Lejeindtægt',
            totalArea: 'Samlet areal',
            totalPotentialIncome: 'Samlet potentiel leje',
        },
        areaAvailable: 'Ledig areal',
        areaLeased: 'Lejet areal',
        areaRatio: 'Arealbelægningsprocent',
        areaToExpire: 'Udløbende areal',
        areaType: 'Type',
        buildingAddress: 'Address',
        buildingNo: 'Nr.',
        floor: 'Etasje',
        leaseObject: 'Lejeobjekt',
        leaseObjectId: 'Lejeobjekt Id',
        markedsprisLedigAreal: 'Markedsværdi (NOK)',
        markedsprisPerM2: 'M. værdi m²',
        physicalArea: 'Areal',
        plotId: 'GrunnID',
        property: 'Ejendom',
        roomNo: 'SoneNr.',
        section: 'Seksjon',
        title: '{{count}} lokaler er ledige',
    },
    portfolio: {
        all: 'Alle porteføljer',
        select: 'Vælg portefølje',
    },
    region: {
        all: 'Alle regioner',
        select: 'Vælg regionen',
    },
    filterPanel: {
        nullstill: 'Nulstil',
        alle: 'Alle',
        portefolje: 'Portefølje',
        region: 'Region',
        status: 'Status',
        endretEtter: 'Ændret efter',
        signertEtter: 'Underskrevet efter',
        antall: 'Maks antal',
        tomFelt: 'Ryd feltet',
        laster: 'Indlæser',
        tildeltMeg: 'Tildelt mig',
        visTildelt:
            'Viser skemaer, der er tildelt dig. Søgning og andre filtre er slået fra.',
        sokUtenFiltre:
            'Søger i alle skemaer. Andre filtre er slået fra ved søgning.',
        velgFilter: 'Søg, eller vælg mindst ét filter for at vise skemaer.',
    },
    status: {
        all: 'Alle statusser',
        select: 'Vælg status',
        filter: 'Filtrer',
        selectedCount: '{{antall}} valgt',
    },
    keyfigures: {
        title: 'Nøglefigurer',
        areaTitle: 'Areal',
        economyTitle: 'Økonomisk',
        noContextSelected:
            'Du skal slå en bygningsafdeling op, før du kan se dette',
    },
    forvaltningsplan: {
        title: 'Forvaltningsplan',
        noContextSelected:
            'Du skal slå en bygningsafdeling op, før du kan se dette',
        edit: 'Rediger',
        read: 'Læs',
    },
    users: {
        title: 'Brugeroverblik',
        searchField: 'Søg efter bruger',
        fullname: 'Navn',
        name: 'Fornavn',
        surname: 'Efternavn',
        email: 'E-mail',
        roles: 'Roller',
        region: 'Region',
        noUsers: 'Ingen brugere fundet.',
        editUser: {
            title: 'Administrer bruger',
            titleWithName: 'Administrer bruger: {{name}}',
            backButton: 'Tilbage til brugeroversigt',
            assignRoles: 'Tildel roller',
            rolesDescription: 'Indtast hvilke roller brugeren har',
            assignRegion: 'Tildel region',
            regionDescription: 'Indtast hvilken region brugeren tilhører',
            regionRequired: 'Region er påkrævet',
        },
        showUserInfo: {
            title: 'Vis brugeroplysninger',
            secondaryTitle: 'Bruger info til {{name}}',
            backButton: 'Tilbage til brugeroversigt',
            labelRoles: 'Roller',
            rolesDescription: 'Brugeren har følgende roller',
            labelRegion: 'Region',
            regionDescription: 'Brugeren tilhører følgende region',
            prosjektkontrollerDescription:
                'Brugeren er ansvarlig for følgende bygningsafdelinger og virksomhed som projektcontroller',
            labelBygg: 'Byggeafdelinger',
            labelFirma: 'Virksomheder',
        },
        action: {
            label: 'Handling',
            byggProsjektkontroller: 'Rediger projektcontrolleransvar',
        },
        bpkModal: {
            title: 'Rediger byggeafdelinger og virksomhed til projektcontroller',
            description:
                'Tilføj byggeafdeling og virksomheder, hvor bruger er ansvarlig som projektansvarlig',
            assigned: 'tildelt',
            labelBygg: 'Vælg byggeafdeling',
            labelFirma: 'Vælg virksomhed',
            save: 'Gem',
            assignedByggWarning: 'Følgende bygninger overføres til {{name}}',
            assignedFirmaWarning: 'Følgende virksomhed overgår til {{name}}',
            saveCompletion:
                'Er du sikker på at du vil overføre {{values}} til {{name}}?',
        },
        save: 'Gem',
        regionSelector: {
            Danmark: 'Danmark',
            Trondheim: 'Trondheim',
            Oslo: 'Oslo',
            Sverige: 'Sverige',
            Alle: 'Alle',
            Europa: 'Europa',
        },
        rolesSelector: {
            Teamleder: 'Teamleder',
            Drift: 'Drift',
            Forvalter: 'Forvalter',
            Okonomi: 'Økonomi',
            OkonomiQA: 'Økonomi QA',
            Prosjekteier: 'Projektejer',
            Prosjektleder: 'Projektleder',
            Prosjektkontroller: 'Projektcontroller',
            Prosjektdirektor: 'Projektdirektør',
            Forvaltningsdirektor: 'Forvaltningsdirektør',
            Utviklingsdirektor: 'Udviklingsdirektør',
            Administrerendedirektor: 'Administrerende direktør',
            Okonomisjef: 'Regnskabschef',
            Teknisksjef: 'Teknisk chef',
            'user-admin': 'Brugeradministrator',

            Avdelingsleder: 'Afdelingsleder',
            Ledergruppedirektor: 'Ledergruppedirektør',
            Risikovurderer: 'Risikovurderer',
            Leverandoroppretter: 'Leverandøropretter',
            FagansvarligAapenhetsloven: 'Fagchef Åpenhetsloven',
            Eiendomssjef: 'Ejendomschef',
            Regiondirektor: 'Regionsdirektør',
        },
    },
    formGenerator: {
        approve: 'Godkend',
        disapprove: 'Afvis',
        submit: 'Fuldfør opgaven',
        fieldRequired: 'Dette felt er påkrævet',
        maxLengthExceeded: 'Teksten må ikke være længere end {{max}} tegn',
        characterCount: '{{length}} / {{max}} tegn',
        assign: {
            title: 'Har du brug for hjælp til at udfylde formularen?',
            description:
                'Tildel opgaven "{{oppgave}}" til en kollega med den rigtige rolle ({{rolle}}) for at få hjælp til at udfylde formularen.',
            assignTo: 'Tildel til',
        },
        confirmDialog: {
            confirmDisapproval: 'Er du sikker på, at du vil afvise formularen?',
            confirm: 'Ja, afvis',
        },
        roles: {
            Teamleder: 'Teamleder',
            Drift: 'Drift',
            Forvalter: 'Forvalter',

            Bestiller: 'Bestiller',
            Avdelingsleder: 'Afdelingsleder',
            Ledergruppedirektor: 'Ledergruppedirektør',
            Risikovurderer: 'Risikovurderer',
            Leverandoroppretter: 'Leverandøropretter',

            Prosjekteier: 'Projektejer',
            Prosjektleder: 'Projektleder',
            Teknisksjef: 'Teknisk leder',
            Eiendomssjef: 'Ejendomschef',
            Prosjektdirektor: 'Projektdirektør',
            Forvaltningsdirektor: 'Forvaltningsdirektør',
            Utviklingsdirektor: 'Udviklingsdirektør',
            Regiondirektor: 'Regionsdirektør',
            Administrerendedirektor: 'Administrerende direktør',

            Prosjektkontroller: 'Projektcontroller',
            Okonomi: 'Projektcontroller',
            OkonomiQA: 'Økonomi QA',
            Okonomisjef: 'Regnskabschef',

            'user-admin': 'Brugeradministrator',
        },
        unsupportedFieldType: {
            title: 'Ikke-understøttet felttype',
            message:
                'Feltet du forsøger at vise understøttes ikke i denne formular. Kontroller venligst felttypen eller kontakt support.',
            reloadButton: 'Genindlæs formular',
        },
    },
    leverandor: {
        oppslag: {
            sokLabel: 'Søg (leverandørnummer, org.nummer eller org.navn)',
        },
        title: 'Leverandørstyring',
        heading: 'Leverandør skema',
        placeholder: 'Leverandørliste kommer her',
        abort: 'Afbryd',
        review: 'Gennemgå',
        opprettetAv: 'Oprettet af',
        completedBy: 'Udført af: {{name}}\n{{date}}',
        completedDate: 'Udført: {{date}}',
        ansvarlig: 'Ansvarlig: {{name}}',
        menuItems: {
            leverandor: 'Leverandørliste',
            root: 'Leverandør',
            skjema: 'Form',
            leverandorReport: 'Leverandørrapport',
        },
        noContextSelected: 'Du skal slå en leverandør op, før du kan se dette',
        notFound:
            'Leverandøren, du forsøger at åbne, findes ikke. Gå venligst tilbage til oversigten og vælg en leverandør fra listen.',
        backButton: 'Tilbage til leverandøroversigt',
        header: {
            documentation: 'Dokumentation',
        },
        cantFindProjectSchema:
            'Der opstod en fejl. Kunne ikke finde leverandørform',
        activityAssignedToOtherUser:
            "Opgaven er tildelt '{{assigned}}', du kan derfor ikke ændre/gennemføre opgaven.",
        assignActivityToMe: 'Tildel opgaven til mig',
        insufficientUserRole:
            "Opgaven kræver rollen '{{role}}', du er ikke tildelt denne rolle.",
        adminInformation:
            "Opgaven kræver rollen '{{role}}' og er tildelt '{{assigned}}'. Du har admin-rolle og kan ændre/gennemføre opgaven.",
        completedActivity: 'Opgaven er allerede gennemført.',
        rejectedActivity: 'Skema er blevet afvist.',
        skipActivity:
            'Denne opgave er ikke relevant for flowet og vil blive sprunget over',
        deviationSystemLink: 'Link til afvigelsessystem',
        processDefinition: {
            breadcrumb: 'Flowdiagram',
            back: 'Tilbage til dokumentation',
            title: 'Visuelt diagram af processdefinitions flowdiagram: {{processDefinitionId}}',
            iconTitle:
                'Se mere detaljeret diagram af processdefinitions flowdiagrammer',
            documentationTitle:
                'Dokumentation af processdefinitions flowdiagrammer',
            selector: 'Vælg processdefınition',
            helperText: 'Vælg processdefınition for at filtrere leverandører',
            zoomIn: 'Zoom ind',
            zoomOut: 'Zoom ud',
            resetZoom: 'Nulstil zoom',
            read: 'Åbn eksternt link til Confluence-side for processdefınition(er)',
        },
        table: {
            emptyTableMessage: 'Ingen leverandører fundet',
            orgnummer: 'ORG NUMMER',
            superOfficeContactId: 'Leverandør SO ID',
            d365Leverandornummer: 'Leverandørnummer',
            superOfficeDocumentId: 'SuperOffice Dokument ID',
            navn: 'Navn',
            type: 'Type',
            bestiller: 'Bestiller',
            okonomi: 'Økonomi',
            ansvarlig: 'Tildelt til',
            opprettetAv: 'Oprettet af',
            startDato: 'Startdato',
            fullfortDato: 'Gennemført dato',
            action: 'Handlinger',
            status: 'Status',
            aktivitet: 'Opgave',
            klassifisering: 'Klassificering',
            feltOppdateringFeilet: 'Kunne ikke opdatere feltet {{fieldName}}',
            ugyldigJSONBransje:
                'Feltet for branche indeholder ugyldige data og kan ikke læses.',
            ugyldigJSONKlassifisering:
                'Feltet for klassificering indeholder ugyldige data og kan ikke læses.',
            actionMenuItems: {
                currentHeader: 'Handlinger for form',
                visLeverandorSkjema: 'Vis form',
                dokumentasjon: 'Vis dokumentation',
                lastNedDokument: 'Download dokument',
                forhaandsvisDokument: 'Forhåndsvisning af dokument',
                tildel: 'Tildel ny ansvarlig',
                sendReminder: 'Send påmindelse til ansvarlig',
                sendKommentar: 'Send kommentar til rolleindehaver',
            },
            tildelAnsvarlig: {
                title: 'Tildel ny ansvarlig',
                ansvarlig: 'Ansvarlig',
                tildel: 'Tildel',
                avbryt: 'Annuller',
            },
            roller: {
                Bestiller: 'Bestiller',
                Avdelingsleder: 'Afdelingsleder',
                Ledergruppedirektor: 'Ledergruppedirektør',
                Risikovurderer: 'Risikovurderer',
                Leverandoroppretter: 'Leverandøropretter',
                FagansvarligAapenhetsloven: 'Fagchef Åpenhetsloven',
                Okonomi: 'Økonomi',

                Prosjekteier: 'Projektejer',
                Prosjektleder: 'Projektleder',
                Forvaltningsdirektor: 'Forvaltningsdirektør',
                Utviklingsdirektor: 'Udviklingsdirektør',
                Administrerendedirektor: 'Administrerende direktør',
                Prosjektdirektor: 'Projektdirektør',
                Okonomisjef: 'Regnskabschef',
                Prosjektkontroller: 'Projektcontroller',
                Teknisksjef: 'Teknisk leder',
                Eiendomssjef: 'Ejendomschef',
                Regiondirektor: 'Regionsdirektør',

                Ukjent: 'Ingen roller',
            },
            registreringStatus: {
                Ny: 'Ny',
                Avvist: 'Afvist',
                Fullfort: 'Fuldendt',
            },
        },
        statuses: {
            UnderVurdering: 'Under vurdering',
            Fullfort: 'Fuldendt',
            Avvist: 'Afvist',
        },
        displayStatuses: {
            underGodkjenning: 'Under Godkendelse',
            godkjent: 'Godkendt',
            ikkeGodkjent: 'Ikke Godkendt',
        },
        successfulRegistration: 'Leverandøren er blevet registreret.',
        successfulOperation: 'Handlingen blev udført med succes.',
        notAssignedToUser:
            'Du er ikke tildelt denne opgave og kan derfor ikke gennemføre den.',
        notAllowedToPerformAction:
            'Du har ikke adgang til at udføre denne handling.',
        deleteLeverandor: {
            title: 'Slet form',
            confirmationText: 'Er du sikker på, at du vil slette formen?',
        },
        sendKommentar: {
            title: 'Send kommentar til rolleindehaver',
            selectRole: 'Vælg rolle',
            commentLabel: 'Kommentar',
            send: 'Send',
        },
        opprettLeverandor: {
            title: 'Opret leverandørform',
        },
        createLeverandor: {
            title: 'Opret leverandørform',
            button: 'Opret leverandørform',
            navigateToSchema: 'Gå til skema',
            successfulOperation: 'Leverandør oprettet vellykket.',
            existingProcessFound:
                'En proces for denne leverandør findes allerede.',
            validation: {
                regionRequired: 'Region er påkrævet',
                orgnummerRequired: 'Organisationsnummer er påkrævet',
                orgnummerDigits: 'Organisationsnummer må kun bestå af tal',
                typeRequired: 'Type er påkrævet',
                countryRequired: 'Land er påkrævet',
            },
            region: {
                label: 'Vælg region for leverandøren',
                oslo: 'Oslo',
                trondheim: 'Trondheim',
                sverige: 'Sverige',
                danmark: 'Danmark',
                europa: 'Europa',
            },
            country: {
                Norway: 'Norge',
                Sweden: 'Sverige',
                Denmark: 'Danmark',
                UnitedKingdom: 'Storbritannien',
                Other: 'Andet',
            },
            orgnummer: {
                label: 'Vælg organisation',
                placeholder: 'Søg efter navn eller org.nummer',
                placeholderSweden: 'Søg efter org.nummer',
            },
            manualEntry: {
                nameLabel: 'Virksomhedsnavn',
                namePlaceholder: 'Indtast virksomhedsnavn',
                orgNumberLabel: 'Organisationsnummer',
                orgNumberPlaceholder: 'Indtast org.nummer',
                countryLabel: 'Land',
                countryPlaceholder: 'Indtast land',
            },
            superOffice: {
                label: 'SuperOffice-kontakt',
                loading: 'Søger i SuperOffice...',
                notFoundAlert: 'Ingen eksisterende virksomhed fundet',
                notFoundAlertDescription:
                    'En ny virksomhed vil blive oprettet i SuperOffice',
                foundAlert: 'Eksisterende virksomhed fundet',
                foundAlertDescription:
                    'Eksisterende virksomhed vil blive brugt: {{navn}}',
                error: 'Fejl ved søgning i SuperOffice',
                selectOption: 'Vælg virksomhed',
                companyId: 'SuperOffice virksomheds-ID',
                klassifisering: 'Klassificering',
            },
            duplicateSuperofficeContactsFound:
                '{{count}} eksisterende SuperOffice-virksomheder fundet for denne organisation. Vælg venligst hvilken du vil bruge:',
            type: {
                label: 'Type',
                fastleverandor: 'Leverandør',
                engangsleverandor: 'Engangsleverandør',
                engangsleverandorInfo:
                    'En engangsleverandør kan kun bruges én gang for beløb mindre end 15 000 NOK/15 000 SEK/10 000 DKK (eks. MVA)',
            },
        },
        TildelKommentarer: {
            field: {
                label: 'Bemærkning ved tildeling',
                placeholder: 'Skriv en bemærkning til den person, du tildeler',
                error: {
                    commentTooLong:
                        'Kunne ikke gemme kommentaren i formularen. Kommentaren er for lang og overskrider tilladt længde.',
                },
            },
            list: {
                title: 'Bemærkninger ved tildeling',
                empty: 'Ingen bemærkninger',
            },
        },
        rolleKommentarer: {
            list: {
                title: 'Kommentarer',
                empty: 'Ingen bemærkninger',
                reply: 'Svar',
                replyTo: 'Svar til {{role}}',
                cannotDelete: 'Kan ikke slette kommentarer med svar',
                fra: 'Fra',
                til: 'Til',
                svarTil: 'Svar til',
            },
            field: {
                error: {
                    commentTooLong:
                        'Bemærkningen er for lang og overskrider tilladt længde.',
                },
            },
        },
        risikovurdering: {
            openButton: 'Åbn Risikovurdering',
            updateButton: 'Udfyld felter med værdier fra Risikovurdering',
            button: 'Risikovurdering',
            notFoundInDNB:
                'Kan ikke finde leverandør i DNB til risikovurdering',
            fieldsUpdated: 'Felterne er blevet opdateret',
            updateError: 'Fejl ved opdatering af felter',
            fetchError: 'Fejl ved hentning af risikovurderingsdata',
        },
        inherentRisk: {
            breadcrumb: 'Iboende risiko',
            title: 'Brancher - Iboende risiko',
            subtitle: 'Vurdering af iboende risiko for forskellige brancher',
            selectRiskLabel: 'Vælg risikoniveau',
            low: 'Lav risiko',
            medium: 'Medium risiko',
            high: 'Høj risiko',
            notSet: 'Ikke angivet',
            searchPlaceholder: 'Søg efter branche',
            success: 'Risikovurdering opdateret',
            error: 'Fejl ved opdatering af risikovurdering',
            table: {
                bransje: 'Branche',
                beskrivelse: 'Beskrivelse',
                risk: 'Risikoniveau',
            },
        },
        schemaRisk: {
            low: 'Lav',
            medium: 'Medium',
            high: 'Høj',
            schemaWarning:
                'Leverandørens vurdering viser høj risiko ifm. den norske Åpenhetsloven. Lucas van Laack (bæredygtighedschef) vil blive inkluderet i processen med en due diligence-vurdering og videre opfølgning. Husk at bestilleren altid er risikoejeren.',
            schemaSafe:
                'Vurderingen viser lav eller medium risiko ifm. den norske Åpenhetsloven. Ingen tiltag nødvendig.',
        },
        processId: 'Proces-ID',
        startDate: 'Startdato',
        startedBy: 'Startet af',
        region: 'Region',
    },
    project: {
        title: 'Projekt- og tiltagsformer',
        header: {
            documentation: 'Dokumentation',
            fullmakt: 'Fuldmagtsgrænser',
        },
        noContextSelected:
            'Du skal slå en bygningsafdeling op, før du kan se dette',
        notFound:
            'Det projekt, du forsøger at åbne, eksisterer ikke. Vend venligst tilbage til oversigten og vælg et projekt fra listen.',
        backButton: 'Tilbake til prosjektoversikten',
        backButtonHistorikk: 'Tilbage til projektoversigten',
        menuItems: {
            root: 'Projekt / tiltag',
            schema: 'Form',
            report: 'Rapport',
        },
        abort: 'Afbryd',
        review: 'Gennemgå',
        opprettetAv: 'Oprettet af',
        completedBy: 'Udført af: {{name}}\n{{date}}',
        completedDate: 'Udført: {{date}}',
        tildelt: 'Tildelt:',
        ansvarlig: 'Ansvarlig: {{name}}',
        formFields: {
            aarsbudsjett: 'Årsbudsjett',
            mainTitle: 'Projekt- og tiltagsform',
            generelleOpplysningerTitle: 'Generelle oplysninger',
            eiendomsnavn: 'Ejendomsnavn',
            delAvEiendom: 'Del af ejendom',
            utleieareal: 'Lejeareal',
            prosjektareal: 'Projektareal',
            informationOmProsjekt: 'Projektinformation',
            oppstartsdato: 'Startdato',
            mvapliktig: 'Er lejeren momspligtig (0-100%)?',
            opprettetSuperOffice: 'Er projektet oprettet i SuperOffice?',
            lonnsomhetsberegning:
                'Rentabilitetsberegning godkendt af afdelingsleder og gemt i SuperOffice?',
            lonnsomhetsberegningLink:
                'Link til rentabilitetsberegning i SuperOffice',
            signertLeietaker: 'Modtaget lejeaftale underskrevet af lejer?',
            signertLeietakerLink: 'Link til underskrevet lejeaftale',
            signertKLP: 'Lejeaftale underskrevet af KLP?',
            prosjektBudsjett: 'Projektbudget',
            prosjektokonomiTitle: 'Projektøkonomi',
            budsjettert: 'Budgetteret?',
            pbv1: 'PB V1',
            andelKostnadsforing: 'Andel af omkostningsføring',
            leietakerTitle: 'Lejer',
            firmanavn: 'Firmanavn',
            firmanavnSøkeresultat: 'Firmanavn (søgeresultat)',
            organisasjonsnummer: 'Organisationsnummer',
            sendVidereTilTitle: 'Send videre til',
            prosjektleder: 'Projektleder',
            utviklingsdirektor: 'Udviklingsdirektør',
            kommentarerTitle: 'Kommentarer',
            kommentarForvaltningsdirektor: 'Kommentar - forvaltningsdirektør',
            kommentarForvaltningsdirektorGodkjent:
                'Projektet er godkendt af forvaltningsdirektøren med følgende kommentar',
            kommentarUtviklingsdirektor: 'Kommentar - udviklingsdirektør',
            kommentarUtviklingsdirektorGodkjent:
                'Projektet er godkendt af udviklingsdirektøren med følgende kommentar',
            kommentarAdministrerendedirektor:
                'Kommentar - administrerende direktør',
            kommentarAdministrerendedirektorGodkjent:
                'Projektet er godkendt af den administrerende direktør med følgende kommentar',
            kommentarProsjektdirektor: 'Kommentar - projektdirektør',
            kommentarProsjektdirektorGodkjent:
                'Projektet er godkendt af projektdirektøren med følgende kommentar',
            prosjektcontroller: 'Projektkontrollør',

            andreSystemerTtle: 'Andre systemer',
            prosjektNummerAxapta:
                'Oprettet i Axapta og følgende er det korrekte projekt nummer',
            firmaDetaljer: {
                registrertIMvaregisteret: 'Registreret i momsregistret',
                registrertIForetaksregisteret:
                    'Registreret i Virksomhedsregistret',
                registreringsdatoEnhetsregisteret:
                    'Registreret i enhedsregistret',
                registreringsdatoAntallAnsatteNAVAaregisteret:
                    'Registreret i NAV Aa-registret',
                konkurs: 'Konkurs',
                underAvvikling: 'Under afvikling',
                underTvangsavviklingEllerTvangsopplosning:
                    'Under tvangsafvikling eller tvangsopløsning',
            },
            manuellRegistrering: 'Manuel registrering',
            firmanavnManuell: 'Firmanavn',
            manueltRegistrertInfo:
                'Manuelt registreret — ingen data fra Brønnøysundregisteret',
            radioGroup: {
                yes: 'Ja',
                no: 'Nej',
            },
            calculatedSelectorEditable: {
                editedLabel:
                    'Den automatisk beregnede værdi på {{value}} er blevet overskrevet. Du kan nulstille den ved at klikke på krydset i feltet ovenfor.',
            },
        },
        steps: {
            step1: {
                title: 'Definer prosjekt',
                description:
                    'Definer prosjektet og dets formål. Vurder om prosjektet er nødvendigt og om det er i overensstemmelse med KLP Eiendommes strategi og mål.',
            },
            step2: {
                title: 'Kontroller og korriger',
                description:
                    'Kontroller og korriger prosjektet for at sikre, at det er i overensstemmelse med KLP Eiendommes strategi og mål.',
            },
            step3: {
                title: 'Forvaltningsdirektør godkjenning',
                description:
                    'Forvaltningsdirektøren godkender prosjektet og dets formål.',
            },
            step4: {
                title: 'Utviklingsdirektør godkjenning',
                description:
                    'Utviklingsdirektøren godkender prosjektet og dets formål.',
            },
            step5: {
                title: 'Administrerende direktør godkjenning',
                description:
                    'Administrerende direktør godkjenner prosjektet og dets formål.',
            },
            step6: {
                title: 'Prosjektkontroller',
                description:
                    'Prosjektkontroller godkjenner prosjektet og dets formål.',
            },
        },

        opprettProsjekt: {
            title: 'Opret projekt / tiltagform',
            type: 'Type',
            step: 'Skridt',
            selectStep: 'Vælg skridt',
            noStepSelected: '--- Ingen værdi ---',
            superOfficeProsjekt: 'SuperOffice-prosjekt',
            superOfficeProsjektPlaceholder: 'Søg efter SuperOffice-prosjekt',
            opprettProsjektKnapp: 'Opret projekt / tiltagform',
            goToSuperOffice: 'Gå til SuperOffice',
            prosjektskjematype: {
                label: 'Vælg projektskematype',
                hovedprosjekt: 'Hovedprojekt',
                underprosjekt: 'Underprojekt',
            },
            // Hvis der skal laves en analyse af omkostninger og rentabilitet for projektet, vælges "Lønsomhedsvurdering". \n\n
            LTT: 'Hvis der er behov for et forprojekt, enten for at udarbejde et tilbud på en lejer, eller en anmodning om et tilbud til entreprenører, skal du vælge "Forprojekt". \n\nEr lejekontrakten underskrevet og projektleder har valgt entreprenør, kan du gå direkte til "Igennemførelse".',
            KOM: 'Skal du udarbejde nogle simple skitser eller lave anden mindre research forud for et forprojekt, og som har en samlet pris på under 50.000 NOK, skal du vælge "Sketch". \n\nHvis du har brug for en projektleder, eller de samlede omkostninger til skitser og undersøgelser overstiger NOK 50.000, skal du vælge "Forprojekt".',
            TEK: 'Med forprojekt?',
            prosjekterNotFound:
                'Ingen projekter fundet, gå til SuperOffice for at oprette projekt',

            radioGroup: {
                Lonnsomhetsberegning: {
                    title: 'Lønsomhedsvurdering',
                },
                Skisse: {
                    title: 'Sketch',
                    KOM: 'Der er behov for at udarbejde nogle enkle skitser eller foretage andre mindre undersøgelser forud for et forprojekt, med en samlet omkostning på mindre end 50.000,-',
                },
                Forprosjekt: {
                    title: 'Forprojekt',
                    LTT: 'Der er behov for forprojekt, enten for at udarbejde tilbud til lejer eller tilbudsforespørgsel til entreprenører',
                    KOM: 'Der er behov for en projektleder, eller de samlede omkostninger til skitser og undersøgelser overstiger 50.000,-',
                    TEK: 'Der er behov for forprojekt, enten for at udarbejde tilbud til lejer eller tilbudsforespørgsel til entreprenører',
                },
                Gjennomforing: {
                    title: 'Igennemførelse',
                    LTT: 'Kontrakten er underskrevet og projektleder har valgt entreprenør',
                    TEK: 'Kontrakten er underskrevet og projektleder har valgt entreprenør',
                },
                Tilbud: {
                    title: 'Tilbud',
                },
            },
            disabledButton:
                'Velg type og underkategori for å opprette prosjektform',
            occupiedProject: ' --- PROJEKTET ER OPTAGET ---',
            types: {
                LTT: 'Lejertilpasning (LTT)',
                KOM: 'Kommerciel (KOM)',
                TEK: 'Teknisk (TEK)',
                TILTAK: 'Tiltag',
            },
        },
        types: {
            LTT: 'Lejertilpasning',
            LTT_Abbreviation: 'LTT',
            KOM: 'Kommerciel',
            KOM_Abbreviation: 'KOM',
            TEK: 'Teknisk',
            TEK_Abbreviation: 'TEK',
            TILTAK: 'Tiltag',
            Unknown: 'Ukendt type',
        },
        subTypes: {
            Opprettelse: 'Oprettelse',
            Skisse: 'Sketch',
            Igangsettelse: 'Idriftsættelse',
            Bestilling: 'Bestilling',
            Endring: 'Ændring',
            Avslutning: 'Afslutning',
        },
        stepTypes: {
            Ny: 'Ny',
            Avvist: 'Avvist',
            Fullfort: 'Fullført',
        },
        errors: {
            invalidLink: 'Linket er ikke gyldigt',
            invalidProjectNumber:
                'Projektnummer skal have formen "<Virksomhedsnummer>.<D365 serienummer (4 cifre)>" f.eks. "N202.0435"',
            savePrompt: 'Der opstod en fejl under lagring af formularindhold.',
            companyNotSelected:
                'Søg venligst efter virksomhedens navn eller nummer, og vælg en fra listen',
            invalidOrgnumber: 'Ugyldigt organisationsnummer',
            invalidTotalVurderingsskjema:
                'Ugyldigt sum - værdien skal være større end 0',
        },
    },
    prosjekt: {
        cantFindProjectSchema:
            'Der opstod en fejl. Kan ikke finde prosjekt/tiltagskjema',
        oppslag: {
            sokLabel: 'Søg (projektnummer, projektnavn eller ejendom)',
        },
        activityAssignedToOtherUser:
            "Opgaven er tildelt '{{assigned}}', du kan derfor ikke ændre/udføre opgaven.",
        assignActivityToMe: 'Tildel opgaven til mig',
        insufficientUserRole:
            "Opgaven kræver rollen '{{role}}', du er ikke tildelt denne rolle.",
        notCandidateGroupOwner:
            "For at fuldføre denne opgave skal du være tildelt rollen '{{owner}}'. Dine roller er '{{userRoles}}'",
        adminInformation:
            "Opgaven kræver rollen '{{role}}' og er tildelt '{{assigned}}'. Du har admin-rolle og kan ændre/udføre opgaven.",
        completedActivity: 'Opgaven er allerede udført.',
        rejectedActivity: 'Skema er blevet afvist.',
        skipActivity:
            'Denne opgave er ikke relevant for strømmen og springes over',
        processDefinition: {
            breadcrumb: 'Flowdiagram',
            back: 'Tilbage til dokumentation',
            title: 'Visuel fremstilling af flowdiagram for procesdefinition: {{processDefinitionId}}',
            iconTitle:
                'Se mere detaljeret fremstilling af flowdiagram for procesdefinitioner',
            documentationTitle:
                'Dokumentation af flowdiagram for procesdefinitioner',
            selector: 'Vælg procesdefinition',
            helperText: 'Vælg procesdefinition for at filtrere projekter',
            zoomIn: 'Zoom ind',
            zoomOut: 'Zoom ud',
            resetZoom: 'Nulstil zoom',
            read: 'Åbn ekstern link til Confluence side for procesdefinition(er)',
        },
        definitions: {
            prosjekt_ltt_godkjenning: 'Lejertilpasning - Forprojekt',
            prosjekt_ltt_bestilling: 'Lejertilpasning - Gennemførelse',
            prosjekt_ltt_endring: 'Lejertilpasning - Ændring',
            prosjekt_ltt_avslutning: 'Lejertilpasning - Afslutning',
            prosjekt_kom_skisse: 'KOM - Skitse',
            prosjekt_kom_opprettelse: 'KOM - Forprojekt',
            prosjekt_kom_bestilling: 'KOM - Gennemførelse',
            prosjekt_kom_endring: 'KOM - Ændring',
            prosjekt_kom_avslutning: 'KOM - Afslutning',
            prosjekt_tek_igangsettelse: 'TEK - Forprojekt',
            prosjekt_tek_bestilling: 'TEK - Gennemførelse',
            prosjekt_tek_endring: 'TEK - Ændring',
            prosjekt_tek_avslutning: 'TEK - Afslutning',
            tiltak_gjennomforing: 'Tiltag - Gennemførelse',
            tiltak_avslutning: 'Tiltag - Afslutning',
        },
        fullmakt: {
            breadcrumb: 'Fuldmagtsgrænser',
            title: 'Fuldmagtsgrænser for projektskema',
            subtitle:
                'Oversigt over fuldmagter og godkendelsesmyndigheder. Alle beløb er ekskl. moms.',
            groupBy: 'Grupper efter:',
            noGroup: 'Vis alle',
            table: {
                allTitle: 'Alle fuldmagter',
                region: 'Region',
                avdeling: 'Afdeling',
                stilling: 'Stilling',
                innenfor: 'Budgetteret',
                utover: 'Ikke budgetteret',
                endring: 'Ændring i budget',
            },
        },
        statuses: {
            TilbudUnderGodkjenning: 'Tilbud under godkendelse',
            Tilbud: 'Tilbud',
            UnderSkissering: 'Under skitsering',
            Skissert: 'Skitseret',
            LonnsomhetsberegningUnderGodkjenning:
                'Lønsomhedsvurdering under godkendelse',
            Lonnsomhetsberegning: 'Lønsomhedsvurdering',
            ForprosjektUnderGodkjenning: 'Forprojekt under godkendelse',
            Forprosjekt: 'Forprojekt',
            GjennomforingUnderGodkjenning: 'Gennemførelse under godkendelse',
            Gjennomforing: 'Gennemførelse',
            TilEndring: 'Ændring budget under godkendelse',
            Endret: 'Gennemførelse ændret budget',
            TilAvslutning: 'Afslutning under godkendelse',
            Avsluttet: 'Afsluttet',
            Avvist: 'Afvist',
        },
        table: {
            actionMenuItems: {
                stepHeader: 'Opret formular til',
                currentHeader: "Handlinger for '{{stegNavn}}'",
                Igangsettelse: 'Igangsættelse',
                Skisse: 'Skitse',
                Tilbud: 'Tilbud',
                Forprosjekt: 'Forprojekt',
                Godkjenning: 'Godkendelse',
                Gjennomforing: 'Gennemførelse',
                Endring: 'Ændring budget',
                Avslutning: 'Afslutning',
                detaljer: 'Vis detaljer',
                tildel: 'Tildel ny ansvarlig',
                tildelRolle: 'Tildel ny: {{rolle}}',
                sammendrag: 'Vis sammendrag',
                sendReminder: 'Send påmindelse til ansvarlig',
                sendReminderName: 'Send påmindelse til {{name}}',
                dokumentasjon: 'Vis dokumentation',
            },
            tildelAnsvarlig: {
                title: 'Tildel ny ansvarlig',
                ansvarlig: 'Ansvarlig',
                tildel: 'Tildel',
                avbryt: 'Annuller',
                Prosjekteier: 'Projektejer',
                Prosjektleder: 'Projektleder',
                Forvaltningsdirektor: 'Forvaltningsdirektør',
                Utviklingsdirektor: 'Udviklingsdirektør',
                Administrerendedirektor: 'Administrerende direktør',
            },
            roller: {
                Prosjekteier: 'Projektejer',
                Prosjektleder: 'Projektleder',
                Forvaltningsdirektor: 'Forvaltningsdirektør',
                Utviklingsdirektor: 'Udviklingsdirektør',
                Administrerendedirektor: 'Administrerende direktør',
                Prosjektdirektor: 'Projektdirektør',
                Okonomisjef: 'Regnskabschef',
                Prosjektkontroller: 'Projektcontroller',
                Okonomi: 'Projektcontroller',
                Teknisksjef: 'Teknisk leder',
                Eiendomssjef: 'Ejendomschef',
                Regiondirektor: 'Regionsdirektør',
                Ukjent: 'Ingen roller',
            },
            subTypes: {
                Forprosjekt: 'Forprojekt',
                Gjennomforing: 'Gennemførelse',
                Endring: 'Ændring',
                Avslutning: 'Afslutning',
                Tilbud: 'Tilbud',
            },
            registreringStatus: {
                Ny: 'Ny',
                Avvist: 'Afvist',
                Fullfort: 'Fuldført',
            },
            tableTitle: 'Udførte opgaver i trin',
            type: 'TYPE',
            navn: 'NAVN',
            d365Prosjektnummer: 'NUMMER',
            eiendom: 'EJENDOM',
            rolle: 'ROLLE(R)',
            email: 'E-POST',
            signeringsDato: 'SIGNERINGSDATO',
            beskrivelse: 'BESKRIVELSE',
            status: 'STATUS',
            opprettetAv: 'OPRETTET AF',
            endretAv: 'ÆNDRET AF',
            ansvarlig: 'TILDELT TIL',
            startDato: 'STARTDATO',
            sluttDato: 'SLUTDATO',
            fullfortDato: 'FULDFØRT DATO',
            action: 'HANDLING',
            utforelseDato: 'DATO FOR UDFØRELSE',
            oppgave: 'OPGAVE',
            prosjekteier: 'PROJEKTEJER',
            prosjektleder: 'PROJEKTLEDER',
            emptyTableMessage:
                'Vi finder ingen projekter baseret på de filtre, du har valgt.',
            lastNedDokument: 'Download dokument',
            forhaandsvisDokument: 'Forhåndsvis dokument',
            visDetaljertProsjektregistrering:
                'Vis detaljeret oversigt over det valgte procestrin',
            visProsjektSkjema: 'Vis skema',
            visProsjektISuperoffice: 'Åbn projekt i SuperOffice',
            prosjektskjematype: 'PROJEKTSKEMATYPE',
            aapneISuperOffice: 'Åbn projekt i SuperOffice',
        },
        filter: {
            prosjektskjematype: {
                label: 'Skematype',
                all: 'Alle',
                hovedprosjekt: 'Hovedprojekter',
                underprosjekt: 'Underprojekter',
            },
        },
        summary: {
            title: 'Projektsammendrag - {{prosjektNavn}}',
        },
        notification: 'Behandler forespørgsel. Vent venligst...',
        error: 'Der opstod en fejl. Prøv igen senere.',
        deleteProject: {
            title: 'Slet form',
            confirmationText: 'Er du sikker på, at du vil slette formen?',
        },
        successfulRegistration: 'Projektet er blevet registreret.',
        successfulOperation: 'Handlingen blev udført med succes.',
        notAssignedToUser:
            'Du er ikke tildelt denne opgave og kan derfor ikke udføre den.',
        notAllowedToPerformAction:
            'Du har ikke tilladelse til at udføre denne handling.',
        newProcess: 'Nye projekter',
        ongoingProcessForvalter: 'Hos forvalter',
        ongoingProcessFinance: 'Hos økonomi',
        startRegistration: 'Start registrering',
        declined: 'Afvist',
        approved: 'Godkendt',
        forApproval: 'Til godkendelse',
        assignedToMe: 'Tildelt mig',
        avvistKommentarTitle:
            "Opgaven '{{avvistOppgave}}' er afvist med følgende kommentar:",
        stepper: {
            unathorisedStep: 'Du har ikke tilladelse til dette trin',
        },
        vurderingsskjema: {
            close: 'Luk',
            open: 'Åbn vurderingsskema',
            title: 'Vurderingsskema',
            sum: 'Sum: ',
            oppsummeringAvSummer: 'Opsummering af summer',
            sumAlleKategorier: 'Alle kategorier: ',
            sumAktivering: 'Aktivering: ',
            sumKostnadsforing: 'Omkostningsføring: ',
            sumAndelAktivering: 'Andel aktivering: ',
            sumAndelKostnadsforing: 'Andel omkostningsføring: ',
            navn: 'Navn',
            kostkategoriId: 'KostkategoriId',
            kostnadsforing: 'Omkostningsføring',
            aktivering: 'Aktivering',
            total: 'Total',
            totalOversikt: 'Total baseret på skema',
            kommentar: 'Kommentar',
            inputMode: {
                toggleLabel: 'Registrér med totalsum og procentfordeling',
                helperText:
                    'Indtast totalsum og procent pr. række; aktivering og udgiftsføring beregnes automatisk.',
                aktiveringPct: 'Aktivering %',
                kostnadsforingPct: 'Udgiftsføring %',
            },
            error: {
                paakrevdKommentar: 'Kommentar påkrævet',
                hasErrors: 'Skema har {{count}} fejl',
                hasErrors_1: 'Skema har 1 fejl',
            },
        },
        kostnadskalkyle: {
            title: {
                tab: 'Kalkule',
                general: 'Kalkule og lønsomhedsvurdering for projekt',
                kalkyle: 'Kalkule for projekt: {{prosjektNavn}}',
                lonsomhetsberegning:
                    'Lønsomhedsvurdering for projekt: {{prosjektNavn}}',
                modalButton: 'Åbn kalkule',
            },
            submit: 'Indsend kalkyle',
            administrerKostnadstyper: 'Administrer omkostningstyper',
            disabledTab: 'Deaktiveret for denne projekttype',
            leggTilKostnadstype: 'Tilføj omkostningstype',
            addKostnadstype: {
                name: 'Name',
                duplicateError: "Omkostningstypen '{{name}}' findes allerede",
            },
            velgKostnadstype: 'Vælg omkostningstype',
            kostnadstypeWarning:
                'Valgt omkostningstype er markeret som slettet',
            velgKostkategori: 'Vælg omkostningskategori',
            lagrer: 'Gemmer',
            lagre: 'Tilføj',
            prosjektArealM2: 'Projektareal (kvm)',
            risikotilleggSats: 'Sats for risikotillæg (%)',
            prosjektlederSats: 'Sats for projektleder-timer (%)',
            tillegg: {
                title: 'Tillæg',
                risiko: 'Risiko',
                prosjektleder: 'Projektleder',
                time: 'time',
                timer: 'timer',
            },
            leieobjektArealM2: 'Leieobjekt inkl. andel fællesareal (kvm)',
            kontraktsleiePerM2: 'Kontraktsleje pr. m²',
            leieperiode: 'Lejeperiode (år)',
            aarligLeie: 'Årlig leje',
            totalLeie: 'Total leje',
            error: {
                kostnadstypeRequired: 'Kostnadstype er påkrævet',
                satsRequired: 'Sats er påkrævet',
                satsRange: 'Sats skal være mellem 0 og 100',
                enhetRequired: 'Enhed er påkrævet',
                enhetPositive: 'Enhed skal være større end 0',
                prisPerEnhetRequired: 'Pris pr. enhed er påkrævet',
                prisPerEnhetPositive: 'Pris pr. enhed skal være større end 0',
                andelKostnadsforingRequired:
                    'Andel af omkostningsføring er påkrævet',
            },
            table: {
                kostnadstype: 'Omkostningstype',
                beskrivelse: 'Beskrivelse',
                kostnad: 'Omkostning',
                enhet: 'Antal (stk/m/m²)',
                prisPrEnhet: 'Pris pr. enhed',
                aktiveringsandel: 'Aktiveringsandel (%)',
                kostnadsforingAndel: 'Andel af omkostningsføring (%)',
                sumAktivering: 'Sum aktivering',
                handlinger: 'Handlinger',
                addRow: 'Tilføj række',
            },
            summary: {
                section_project: 'Nøgletal om projektet',
                totalKostnad: 'Totalomkostning',
                kvadratMeterPris: 'Kvadratmeterpris',

                section_historical: 'Historiske nøgletal for ejendommen',
                gjennomsnittligKostnadPerM2: 'Gennemsnitlig omkostning pr. m²',

                section_financial: 'Nøgletal for regnskab',
                andelAktiveres: 'Andel aktiveres',
                andelKostnadsfores: 'Andel omkostningsføres',
            },
        },
        lonnsomhet: {
            title: 'Lønsomhed',
            fields: {
                kontraktleieTotaltPerAar: 'Samlet kontraktleje/år',
                grunnleiePerM2: 'Grundleje pr. m²',
                oktLeiePerM2PerAar: 'Øget leje pr. m²/år',
                nyGrunnleiePerM2PerAar: 'Ny grundleje pr. m²/år',
                inflasjon: 'Inflation (%)',
                avkastningskrav: 'Afkastningskrav (%)',
                realAvkastningskrav: 'Reelt afkastningskrav (%)',
                oktInntektPerM2PerAar: 'Øget indtægt pr. m²/år',
                oktInntektPerAar: 'Øget indtægt/år',
                terminerPerAar: 'Terminer pr. år',
                kontraktstid: 'Kontrakttid (år)',
            },
            table: {
                navn: 'Navn',
                investeringskostnad: 'Investeringsomkostning',
                avskrivningstid: 'Afskrivningsperiode',
                restverdi: 'Restværdi (%)',
                aarligOktLeiepris: 'Årlig øget leje',
                oktLeieprisPerM2: 'Øget leje pr. m²',
                leggTilDelprosjekt: 'Tilføj delprojekt',
                totalt: 'Total',
                nettoLeie: 'Nettoleje',
                inkluderMvaKompensasjon: 'Inkluder moms',
                noData: 'Der er ingen data i omkostningskalkulatoren endnu. Udfyld venligst formularen for at se rentabilitetsberegningen.',
            },
        },
        kostnadstyper: {
            title: 'Omkostningstyper',
            showDeleted: 'Vis slettede omkostningstyper',
            table: {
                navn: 'Navn',
                kostkategori: 'Omkostningskategori',
                defaultCost: 'Standardomkostning',
                defaultKostnadsforingAndel:
                    'Standard andel omkostningsføring (%)',
                edit: 'Rediger omkostningstype',
                save: 'Gem omkostningstype',
                add: 'Tilføj omkostningstype',
                delete: 'Slet omkostningstype',
                deletePrompt:
                    'Er du sikker på, at du vil slette omkostningstypen?',
                deleteConfirm: 'Slet',
                cancel: 'Annuller',
                restore: 'Gendan omkostningstype',
                duplicateError:
                    'En omkostningstype med samme navn og omkostningskategori findes allerede',
            },
            error: {
                navnRequired: 'Navn er påkrævet',
                kostKategoriRequired: 'Omkostningskategori er påkrævet',
                duplicate:
                    'Omkostningstypen med navn {{name}} og omkostningskategori {{kostkategori}} findes allerede',
            },
        },
        leverandor: {
            organizationSelect: 'Anmodet virksomhed',
            organizationPlaceholder: 'Organisationsnummer/navn',
            price: 'Pris',
            priceRevised: 'Korrigeret pris',
            selected: 'Valgt',
            klassifisering: 'Klassificering',
            add: 'Tilføj',
        },
        vedlegg: {
            add: 'Tilføj vedhæftning',
            delete: 'Slet vedhæftning',
            loading: 'Uploader vedhæftning',
        },
        budsjettnummer: {
            title: "Budget '{{number}}' i D365",
            period: 'Periode: {{from}} - {{to}}',
            budget: 'ExMVA: {{exMva}}, MVA: {{mva}}, I alt: {{total}}',
        },
        dokument: {
            add: 'Tilføj',
            loading: 'Uploader',
        },
        TildelKommentarer: {
            field: {
                label: 'Kommentar ved tildeling',
                placeholder: 'Skriv en kommentar til personen du tildeler',
                error: {
                    commentTooLong: {
                        da: 'Kunne ikke gemme kommentaren i formularen. Kommentaren er for lang og overskrider den tilladte længde.',
                    },
                },
            },
            list: {
                title: 'Kommentarer ved tildeling',
                empty: 'Ingen kommentarer',
            },
        },
    },
    frontPage: {
        buildings: 'Lokaler',
        buildingsLink: 'Mine lokaler',
        contract: 'Kontraktsforhandling',
        frontpage: 'Forside',
        invoice: 'Faktura',
        invoiceLink: 'Alle fakturaer',
        messages: 'Opslagstavle',
        messagesLink: 'Alle beskeder',
        mytasksLink: 'Sagsoversigt',
        expiredContracts: {
            actionButtonText: 'Detaljer',
            area: 'Areal',
            areaRatio: 'Arealmessig belægningsprocent',
            available: 'Ledig',
            contracts: 'Kontrakter',
            econRatio: 'Økonomisk belægningsprocent',
            income: 'Lejeindtægt',
            marketValue: 'Markedsværdi',
            nokperyear: 'NOK/År',
            rented: 'Lejet ud',
            rentedExpiring: 'Udløber',
            title: 'Tilgængelige lokaler',
            yourAvailableAreasDate: 'Dine tilgængelige lokaler pr ',
            yourRentedAreasDate: 'Dine tilgængelige lokaler pr ',
        },
        expiringContracts: {
            actionButtonText: 'Detaljer',
            area: 'Areal',
            income: 'Leieinntekter',
            title: 'Kontraktsudløb',
            yourExpiringContracts: 'Dine udløbne kontrakter',
            yourRentalRateDate: 'Din belægningsgrad pr ',
        },
        utestaaendeFordringer: {
            allReceivables: 'Alle tilgodehavender',
            actionButtonText: 'Mine tilgodehavender',
            emptyResult:
                'Du har ingen udestående tilgodehavender som trenger oppfølging.',
            title: 'Tilgodehavender',
            subtitle: 'Kunder med Udestående betalinger',
        },
        contractManagement: {
            actionButtonText: 'Kontraktstyring',
            contractsToRegistration: 'Afventer registrering i D3655',
            negotiations: 'Forhandlinger',
            signableContracts: 'Kontrakter til underskrivelse',
            subtitle: 'Kontraktstyring',
            title: 'Kontrakter',
            newProsessLink: 'Start ny proces',
            infoText:
                'Denne kontraktoversigt er ikke filtreret på den valgte bygning.',
        },
        project: {
            actionButtonText: 'Projektformular',
            subtitle: 'Projektstyring',
            title: 'Projekter',
            newProjectLink: 'Opret nyt projekt',
            infoText:
                'Denne projektoversigt er ikke filtreret på den valgte bygning.',
        },
        sak: {
            actionButtonText: 'Sagsoversigt',
            subtitle: 'Sagsopfølgningg',
            title: 'Sager',
            noTickets: 'Ingen sager',
            sakStatus: {
                Aktiv: 'Aktiv',
                Avsluttet: 'Afsluttet',
                Sammenslått: 'Fusioneret',
                Slettet: 'Slettet',
                Unknown: 'Ukendt',
                Utsatt: 'Utsatt',
                'Venter på 3dje part': 'Venter på 3dje part',
                'Venter på kunde': 'Venter på kunde',
                Påbörjad: 'Begynt',
                'Ej påbörjad': 'Ikke begynt',
            },
        },
        welcome: {
            forvalter: 'Velkommen til Dashbordet for fast ejendom',
            yourAdminDashboard:
                'Velkommen til Dashbordet for fast ejendom, {{name}}',
        },
        adjustFrontpage: {
            title: 'Tilpas forside',
            alert: 'Nu vises standardforsiden for din rolle. Du kan nemt tilpasse forsiden efter dine behov nedenfor.',
            select: 'Vælg hvad der vises på forsiden',
            frontpageCardsSelector: {
                utestaaendeFordringer: 'Udestående tilgodehavender',
                arealmessigUtleiegrad: 'Arealmessig belægningsprocent',
                kontrakter: 'Kontrakter',
                prosjekter: 'Projekter/tiltag',
                saker: 'Sager',
                leverandor: 'Leverandør',
            },
        },
        survey: {
            title: 'Hej{{name}}!',
            description1:
                'Har du 5 minutter til at give feedback om hvordan vi kan forbedre Dashbordet for fast ejendom?',
            description2: 'Vi i IT-afdelingen sætter stor pris på din hjælp!',
            linkText: 'Gå til undersøgelsen',
        },
        leverandor: {
            title: 'Leverandør',
            subtitle: 'Leverandør',
            assignedToMe: 'Tildelt mig',
            underAssessment: 'Under vurdering',
            completed: 'Afsluttet',
            rejected: 'Afvist',
            actionButtonText: 'Leverandørformular',
        },
    },
    general: {
        backToTop: 'Tilbage til toppen',
        by: 'af',
        cancel: 'Afbryd',
        charactersRemaining: '{{count}}% tegn tilbage',
        clear: 'Tøm',
        clearList: 'Ryd listen',
        clearSelection: 'Ryd markeringen',
        close: 'Luk',
        confirm: 'Ja',
        contextSelectorSearchField: 'Søg efter bygningsafdeling',
        contextSelectorHint: "Legg til byggavdeling i liste over 'Mine bygg'",
        days_0: 'dag',
        days: 'dage',
        decline: 'Nej',
        delete: 'Slet',
        deleteYes: 'Ja, slet',
        details: 'Detaljer',
        download: 'Hent',
        draft: 'Kladde',
        edit: 'Redigér',
        emptyList: 'Listen er tom',
        error: {
            title: 'Fejl',
            message: 'Der opstod en fejl.\nPrøv igen senere.',
            messageWithDetails:
                'Der opstod en fejl:\n{{errorMessage}}.\nPrøv igen senere.',
            apiErrorTitle: 'Fejlmeddelelser:',
            apiErorTitle_1: 'Fejlmeddelelse:',
            apiError:
                'Der opstod en fejl ved indhentning af data. Udviklingsteamet er blevet underrettet. Vi beklager ulejligheden.',
            reloadPage: 'Genindlæs siden',
        },

        expired: 'Udløbet',
        expiryTime: {
            expired: '(Har udløbet)',
            expires_within_6m: '(6 mndr)',
            expires_within_1y: '(1. år)',
            expires_within_2y: '(2 år)',
            expires_within_3y: '(3 år)',
            expires_within_4y: '(4 år)',
        },
        links: 'Links',
        goBack: 'Gå tilbage',
        goBackToFrontpage: 'Vend tilbage til forsiden',
        loading: 'Laster...',
        menu: 'Menu',
        month_0: 'Jan',
        month_1: 'Feb',
        month_10: 'Nov',
        month_11: 'Des',
        month_2: 'Mar',
        month_3: 'Apr',
        month_4: 'Maj',
        month_5: 'Jun',
        month_6: 'Jul',
        month_7: 'Aug',
        month_8: 'Sep',
        month_9: 'Okt',
        month: 'Måned',
        // tslint:disable-next-line: max-line-length
        noIe: 'Vi beklager, men denne funktion understøttes ikke i Internet Explorer. Vi anbefaler at bruge Google Chrome eller Mozilla Firefox browser.',
        name: 'Navn',
        of: 'af',
        open: 'Åbn',
        pageNotFound: 'Kunne ikke finde siden',
        preview: 'Preview',
        previewDownload: 'PREVIEW / HENT',
        publish: 'Publicér',
        readMore: 'Læs mere',
        reload: 'Genindlæs',
        reset: 'Nulstil',
        revert: 'Nulstil',
        save: 'Gem',
        saveAsDraft: 'Gem som kladde',
        saved: 'Gemt',
        saving: 'Gemmer...',
        savingError: 'Fejl under lagring',
        show: 'vis',
        showAll: 'Vis alle',
        submit: 'Indsend',
        sum: 'sum',
        updating: 'Opdatering...',
        unknown: 'Ukendt',
        wrote: 'skrev',
    },
    languageName: 'Dansk',
    report: {
        error: 'Fejl ved lasting av rapporter.',
        name: {
            ArealOgKontrakt: 'Område og Kontrakter',
            Kundereskontro: 'Kundehovedbog',
            Prosjekt: 'Projekt',
            Regnskap: 'Regnskab',
        },
        open: 'Åbne',
        report: 'Rapport',
        title: 'Rapporter',
    },
    tables: {
        antallTreff_one: '{{count}} resultat',
        antallTreff: '{{count}} resultater',
        body: {
            noMatch: 'Beklager, vi fant ingen resultat',
            toolTip: 'Sorter',
            toolTipFor: 'Sorter ',
        },
        pagination: {
            displayRows: 'av',
            next: 'Neste side',
            previous: 'Forrige side',
            rowsPerPage: 'Rader per side:',
        },
        toolbar: {
            downloadCsv: 'Last ned CSV',
            filterTable: 'Filtrer tabell',
            print: 'Skriv ut',
            search: 'Søk',
            viewColumns: 'Vis kolonner',
        },
        filter: {
            all: 'Alle',
            reset: 'Tilbakestill',
            title: 'Filtre',
        },
        viewColumns: {
            title: 'Vis Kolonner',
            titleAria: 'Vis/skjul tabell kolonne',
        },
        selectedRows: {
            delete: 'Slett',
            deleteAria: 'Slett valgt rad',
            text: 'rad(er) valgt',
        },
        labelRowsPerPage: 'Rækker pr. side:',
    },
    validator: {
        email: 'Gyldig epost er påkrævet!',
        required: 'Felt er påkrævet! ',
    },
    sustainability: {
        prosjektAvfall: {
            title: 'Bæredygtighed i projekter',
            description:
                'Denne rapport viser oplysninger om afsluttede projekter inden for en given periode. Data for individuelle projekter er anført i tabellen.',
            fromDate: 'Afsluttet, fra dato',
            toDate: 'Afsluttet, til dato',
            reset: 'Nulstil til sidste kvartal',
            uploadRapport: 'Upload slutrapport manuelt',
            projectLabel: 'Vælg projekt',
            projectWarning:
                'Projektet har allerede en slutrapport, denne vil blive overskrevet af ny slutrapport.',
            selectFile: 'Vælg fil',
            uploadRapportSuccess: 'Slutrapporten er uploadet og analyseres.',
            sluttrapportLabel: 'Slutrapport',
            lastOppRapport: 'Upload slutrapport',
            uploadKlimagass: 'Indtast drivhusgasudledning manuelt',
            lagreKlimagass: 'Gem drivhusgasudledning',
            updateKlimagassSuccess: 'Drivhusgasudledning opdateret',
            summary: 'Sammenfatning',
            antallProsjekter: 'Antal projekter',
            antallProsjekterMedRapport: 'Antal projekter med slutrapport',
            totalAvfall: 'Total affald',
            sorteringsgrad: 'Sorteringsgrad',
            tableTitle: 'Projekter',
            prosjektnummer: 'Nummer',
            prosjekttype: 'Type',
            prosjektnavn: 'Navn',
            region: 'Region',
            byggtype: 'Ejendomstype',
            bygg: 'Ejendom',
            prosjektleder: 'Projektleder',
            klimagassberegning: 'Beregnet klimagassudslip',
            klimagassRelevant: 'Klimagasberegning relevant',
            klimagassRelevantHint:
                'Projektlederens svar ved opstart: Er en klimagasberegning (Reduzer el. lign., A1–A5 iht. NS 3720:2018) relevant for projektet?',
            klimagassForklaring: 'Begrundelse (hvis nej)',
            relevantJa: 'Ja',
            relevantNei: 'Nej',
            lesMer: 'Læs mere',
            prosjektSum: 'Affaldsvolumen',
            document: 'Slutrapport',
            documentTooltip: 'Vis slutrapport',
            emptyTable: 'Ingen afsluttede projekter fundet',
            sortert: 'Total sorteret',
            usortert: 'Total usorteret',
            sum: 'Sum',
            sorteringHeader: 'Sortering',
            avfallTypeHeader: 'Varegruppe',
            beskrivelseHeader: 'Beskrivelse',
            transporterHeader: 'Antal transporter',
            volumHeader: 'Affaldsvolumen',
            volumAndelHeader: 'Andel',
            analyzeAction: 'Analyser rapporten igen',
            analyzeWarning:
                'Tidligere affald til projektet vil blive overskrevet',
            editAction: 'Manuel redigering',
            addRow: 'Tilføj række',
            updateSuccess: 'Affald opdateret',
            error: {
                validation: 'Ret venligst fejlene før lagring',
                invalidMengde: 'Mængde skal være større end eller lig 0',
                invalidKlimagassberegning:
                    'Klimagasberegning skal være større end eller lig 0',
                typeRequired: 'Affaldstype er påkrævet',
            },
        },
    },
    reportMapping: {
        menu: {
            title: 'Energinet rapportkobling',
        },
        breadcrumbs: {
            reportMapping: 'Energinet rapportkobling',
            documentation: 'Dokumentation',
        },
        documentation: {
            title: 'Dokumentation',
            openExternal: 'Åbn ekstern link til Confluence side',
            backButton: 'Tilbage til rapportkobling',
            viewInConfluence: 'Åbn dokumentationen i Confluence',
        },
        mappingAdd: {
            title: 'Ny kobling',
            titleMappingFor: 'Ny kobling for rapport:',
            selectReport: 'Vælg rapport',
            selectBuilding: 'Vælg bygning',
            selectCustomer: 'Vælg kunde',
            selectReportType: 'Vælg rapporttype',
            searchBuildings: 'Søg efter bygninger...',
            searchCustomers: 'Søg efter kunder...',
            searchReports: 'Søg efter rapporter...',
            save: 'Gem',
        },
        mappingEdit: {
            title: 'Rediger kobling',
            titleMappingFor: 'Rediger kobling for rapport:',
            save: 'Opdater',
        },
        mappingTransfer: {
            title: 'Overfør rapport',
            titleMappingFor: 'Overfør rapport:',
            transfer: 'Overfør',
            success:
                'Rapporten blev overført og synkroniseret med andre systemer.',
            disclaimer:
                'NB! Ved lagring af rapporten vil den blive synkroniseret med andre systemer. Det kan tage op til 3 minutter. Luk venligst ikke vinduet før synkroniseringen er fuldført.',
            disclaimerNightly:
                'Hvis du ikke vil overføre nu, vil rapporterne blive overført ved natlig synkronisering',
        },
        mappingTable: {
            type: 'Type',
            report: 'Rapport',
            building: 'Bygning',
            customer: 'Kunde',
            actions: 'Handlinger',
            filterByStatus: 'Filtrer efter status',
            all: 'Alle',
            mapped: 'Koblet',
            unmapped: 'Ikke koblet',
        },
        mappingDelete: {
            title: 'Slet kobling',
            confirmationText:
                'Er du sikker på, at du vil slette denne kobling?',
        },
        mappingsSummary: {
            totalMappings: 'Rapporter',
            withBygg: 'Koblet til bygning',
            withKunde: 'Koblet til bygning og kunde',
        },
        error: {
            noAvailableReports:
                'Ingen tilgængelige rapporter at koble til for den valgte bygning.',
            saveFailed: 'Kunne ikke gemme rapporten. Prøv venligst igen.',
            transferFailed:
                'Rapporten blev gemt, men synkronisering med andre systemer mislykkedes. Synkroniseringen vil blive forsøgt igen automatisk.',
        },
        reportType: {
            Unknown: 'Ukendt',
            Energy: 'Tidsserierapport om energibærere',
            Waste: 'Affaldrapport om fraktioner eller fraktionsgrupper',
            MonthlyEnergy: 'Månedlig rapport om energibærere',
            Water: 'Vandrapport om forbrug sidste 24 måneder',
            AdjustedEnergy:
                'Graddagskorrigeret energirapport, for i år relativt til sidste 4 år',
            MonthlyCustomerEnergy:
                'Månedlig rapport om energibærere (kun for kundeportalen)',
            CustomerSpecificEnergy: 'Energirapport specifik for kunde',
        },
    },
    devRoleSelector: {
        label: 'Valgt testrolle',
        heading: 'Vælg testrolle',
        original: 'Original (rigtig rolle)',
        forvalterKontor: 'Forvalter – Kontor (Asbjørn)',
        forvalterKjopesenter: 'Forvalter – Kjøpecenter (Carl Christian)',
        okonomi: 'Økonomi (Valarmathy)',
        okonomiQA: 'Økonomi QA (Solrunn)',
        prosjektleder: 'Projektleder/Projektejer (Henriette)',
    },
};
